import React from 'react';
import { AppIcon } from './AppIcon';

const MEDAL_COLORS = ['#FFD700', '#C0C0C0', '#CD7F32'] as const;

interface RankMedalProps {
  /** 0-based leaderboard index */
  index: number;
  className?: string;
  fontSize?: 'inherit' | 'small' | 'medium' | 'large';
}

/** Gold / silver / bronze medal for top-3 ranks; otherwise renders "N." */
export const RankMedal: React.FC<RankMedalProps> = ({
  index,
  className,
  fontSize = 'inherit',
}) => {
  if (index < 0 || index > 2) {
    return <span className={className}>{index + 1}.</span>;
  }

  return (
    <AppIcon
      name="medal"
      className={className}
      fontSize={fontSize}
      sx={{ color: MEDAL_COLORS[index], verticalAlign: 'middle' }}
      aria-hidden
    />
  );
};
